<template>
    <div class="progress-container">

        <div class="bar-container">
            <div class="color short-anim" v-if="isShort" ></div>
            <div class="color long-anim" v-if="isLong" ></div>

        </div>
        <div class="count" v-bind:style="countStyle">{{count}}</div>

    </div>
</template>

<script>
    export default {
        name: "Loading",
        mounted() {
            this.isShort ? this.count =15 : this.count = 60
            setInterval(()=>{
                this.count --;
                if (this.count === 0) {
                   this.$emit('onRecordDone');
                } else if (this.count === 5) {
                    this.countStyle = {
                        color: 'red'
                    };
                }

            },1000)
        }
        ,

        data() {
            return {
                countStyle: {
                    color:'white',
                },
                count : Number
            }
        },
        props:{
            isShort: {
                default: false,
                type: Boolean
            },
            isLong: {
                default: false,
                type: Boolean
            }
        }
    }
</script>

<style lang="scss" scoped>
    .count{
        color: white;
        font-size: 1.3em;
        margin-left: 8px;
    }
    .short-anim{
        animation: charging 15s;
    }
    .long-anim {
        animation: charging 60s;
    }
    .progress-container{
        display: flex;
        justify-content: center;
        align-items: baseline;
        width: 90%;

        top: 0;
    }
    .bar-container{
        width: 80%;
        height: 2vh;
        border: solid 1px #979797;
        border-radius: 10px 10px 10px 10px;

        display: flex;
        align-items: center;
        background-color: white;
        margin-top: 10%;
        @media screen and (max-width: 640px) {
            width: 100vw;
        }
    }
    .color{
        height: 100%;
        width: 5%;
        background: #CF4C4F;
        border-radius: 10px 10px 10px 10px;
    }
    @keyframes charging {
        0%{width: 0%}
        100%{width: 100%}
    }
</style>
